import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/purchase-confirm`;

// عميل عام بلا توكن — الرمز في الرابط هو الإثبات.
export const fetchConfirmView = async (token) => (await axios.get(`${BASE}/${token}`)).data;
export const submitConfirmation = async (token, body) => (await axios.post(`${BASE}/${token}`, body)).data;
